import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    // {
    //   path: '/ecommerce-conversion',
    //   name: 'CROChecklist',
    //   component: () => import("@/pages/CROChecklist.vue"),
    //   meta: { requiresAuth: false, layout: 'no-sidebar' }
    // },    
    // {
    //   path: '/website-audit',
    //   name: 'WebsiteAudit',
    //   component: () => import("@/pages/WebsiteAudit.vue"),
    //   meta: { requiresAuth: false, layout: 'no-sidebar' }
    // },        
    {
      path: '/',
      name: 'Home',
      component: () => import("@/pages/CROChecklist.vue"),
      meta: { requiresAuth: false, layout: 'no-sidebar' }
    },
    { path: '*', redirect: '/' }
  ],
  mode: 'history'
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js